import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogContentText } from "@mui/material"
import React, { useState } from "react";
import { DeleteButton } from "../../../app/components/DeleteButton";
import { CancelButton } from "../../../app/components/CancelButton";
import { useAppDispatch } from "../../../app/hooks";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { deleteSystemRoleResponsibility } from "./systemRoleReponsibilitiesApi";

interface DeleteSystemRoleResponsibilityDialogProps {
    systemRoleResponsibilityId: string;
    onSaveSuccess: (systemRoleResponsibility: string) => void;
    onCancel: () => void;
}

export const DeleteSystemRoleResponsibilityDialog: React.FC<DeleteSystemRoleResponsibilityDialogProps> = ({ systemRoleResponsibilityId, onSaveSuccess, onCancel }) => {
    const dispatch = useAppDispatch();

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleConfirm = async () => {
        try {
            const result = await dispatch(deleteSystemRoleResponsibility(systemRoleResponsibilityId))
            if (deleteSystemRoleResponsibility.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSaveSuccess(systemRoleResponsibilityId);
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <Localized id="confirm-delete">
                        <span>Czy napewno chcesz usunąć?</span>
                    </Localized>
                </DialogContentText>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <DeleteButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>
    )
}